// extracted by mini-css-extract-plugin
export default {"group":"Dtl_group__FZwiV","item":"Dtl_item__iA7+y","label":"Dtl_label__DIYSq","muted":"Dtl_muted__8KcbS","value":"Dtl_value__vq4DU"};